import { Component, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd';
import { updateHostClass } from '@delon/util';
import { SettingsService } from '@delon/theme';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ToolsService } from '../../services/tools.service';
import { WebSocketService } from '../../services/websocket.service';

@Component({
  selector: 'layout-default',
  templateUrl: './default.component.html',
})
export class LayoutDefaultComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  isFetching = false;

  constructor(
    private router: Router,
    private _message: NzMessageService,
    private settings: SettingsService,
    private el: ElementRef,
    private renderer: Renderer2,
    private sw: WebSocketService,
    public toolsServer: ToolsService,
  ) {
    this.toolsServer.setFetchingStatus(false);

    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((evt: any) => {
      if (!this.isFetching && evt instanceof RouteConfigLoadStart) {
        this.isFetching = true;
      }
      if (evt instanceof NavigationError || evt instanceof NavigationCancel) {
        this.isFetching = false;
        
        if (evt instanceof NavigationError) {
          this._message.error(`无法加载${evt.url}路由`, { nzDuration: 1000 * 3 });
        }
        return;
      }
      if (!(evt instanceof NavigationEnd || evt instanceof RouteConfigLoadEnd)) {
        return;
      }

      if(evt instanceof NavigationEnd){
        window.sessionStorage.setItem("lastRouter",evt.url);
      }
      if (this.isFetching) {
        setTimeout(() => {
          this.isFetching = false;
        }, 100);
      }
    });
  }

  private setClass() {
    const { el, renderer } = this;
    // const layout = settings.layout;
    updateHostClass(el.nativeElement, renderer, {
      ['alain-default']: true,
      ['alain-default__fixed']: true,
      ['alain-default__collapsed']: false,
    });
  }

  ngOnInit() {
    const { settings, unsubscribe$ } = this;
    settings.notify.pipe(takeUntil(unsubscribe$)).subscribe(() => this.setClass());
    this.setClass();

    // 添加全局websocket监听
    this.sw.creatWebsocket();
  }

  ngOnDestroy() {
    const { unsubscribe$ } = this;
    unsubscribe$.next();
    unsubscribe$.complete();

    // 销毁全局websocket对象
    this.sw.destroyWebsocket();
  }
}
